// @ts-ignore
import { get, remove, set, CookieAttributes } from 'js-cookie';

function expire(key: string, options?: CookieAttributes) {
  remove(key, options);
}

function isEnabled() {
  if (typeof document === 'undefined') {
    // running in server context
    return false;
  }

  // Emulate the old `enabled` method from `ScottHamper/Cookies` repo,
  // But we'll also check if to see we allow secure, non same-site cookies.
  // @see https://github.com/ScottHamper/Cookies/blob/master/src/cookies.js#L145-L150

  set('cookies', 'true');
  set('cookies-same-site', 'true', { sameSite: 'none', secure: true });
  const exists = get('cookies') ?? get('cookies-same-site');
  expire('cookies');
  expire('cookies-same-site');
  return exists;
}

export default {
  isEnabled,
  get,
  set,
  expire,
};
